import { get, del, post, put, download, postFd } from "@utils/axios";

const api = "payslips";

// -------- Salary Disbursement (actual payment / release tracking) --------
export const disburseReq = (payload) => {
  return postFd(`disbursements`, payload);
};
export const bulkDisburseReq = (payload) => {
  return post(`disbursements/bulk`, payload);
};
export const voidDisbursementReq = (payload) => {
  return post(`disbursements/${payload.id}/void`, payload);
};
export const getDisbursementsReq = (payload) => {
  return get(`disbursements?payslip_id=${payload.payslip_id}`);
};
export const getAllDataReq = (payload) => {
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
};

export const createDataReq = (payload) => {
  return post(`${api}`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};
export const cancelRequestReq = (payload) => {
  return post('cancelRequest', payload);
};

export const deleteDataReq = (payload) => {
  return del(`${api}/${payload.id}?page=1&filters=${payload.filters}`);
};

export const getRosterReq = (payload) => {
  return post(`${api}/getRoster`, payload);
};
export const getExpectedTimeReq = (payload) => {
  return get(`${api}/getExpectedTime?&attendance_date=${payload.date}&employment_id=${payload.employment_id}`);
};

export const getFilterReq = (payload) => {
  return get(`filters?${localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1}&fields=page=1&filters=supporting_fields_|employments,employments,payroll;preset_|my_payslip;`)
}
export const onDateChange = (payload) => {
  return post(`${api}/dateChange?&`, payload)
}
export const onShiftSelectionChangeReq = (payload) => {
  return post(`${api}/shiftSelectionChange?&`, payload)
}

export const getRelatedDataByReqIdReq = (payload) => {
  return get(`${api}/${payload}`)
};

//download 
export const downloadPayslipReq = (payload) => {
  return download(`${api}/download?filters=${payload.filters}`)
};

//recalculate payslip 
export const regeneratePayslipReq = (id) => {
  return post(`${api}/regenerate/${id}`)
};


